export default (that, disabled) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !disabled,
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('form_label_picture') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    visible: !disabled && !that.buttonFlag,
    width: 40,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'opt1',
    },
    titleHelp: {
      message:
        that.$l('Press_and_hold_and_drag_to_adjust_the_list_order!') ||
        '按住后拖拽，可调整列表顺序！',
    },
  },
  {
    field: 'materialNo',
    align: 'left',
    headerAlign: 'left',
    minWidth: 180,
    title: that.$l('table_label_fabric_no') || '面料编号',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNoInfo' },
  },
  {
    field: 'memo',
    align: 'left',
    headerAlign: 'left',
    minWidth: 180,
    title: that.$l('table_label_memo') || '备注',
    showHeaderOverflow: 'title',
  },
  {
    field: 'materialName',
    align: 'left',
    headerAlign: 'left',
    minWidth: 230,
    title: that.$l('table_label_fabric_name') || '面料名称',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNameInfo' },
  },
  {
    field: 'displayName',
    align: 'left',
    headerAlign: 'left',
    minWidth: 260,
    title: that.$l('table_label_display_name') || '属性描述',
    showHeaderOverflow: 'title',
    slots: { default: 'displayNameInfo' },
  },
  {
    field: 'metadataDesc',
    align: 'left',
    headerAlign: 'left',
    minWidth: 200,
    title: that.$l('table_label_metadata_desc') || '门幅/克重',
    showHeaderOverflow: 'title',
  },
  {
    field: 'usageQty',
    align: 'center',
    headerAlign: 'center',
    minWidth: 100,
    title: that.$l('table_label_usageQty') || '耗料',
    showHeaderOverflow: 'title',
    slots: { default: 'usageQtyInfo' },
  },
  {
    field: 'price',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_price') || '单价',
    showHeaderOverflow: 'title',
    required: 'validRules',
    slots: { default: 'price' },
  },
  {
    field: 'subTotal',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_subTotal') || '成本小计',
    showHeaderOverflow: 'title',
    isTotalColumn: true,
  },
  {
    field: 'scmName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    title: that.$l('table_hand_nameOfManufacturer') || '厂商名称',
    showHeaderOverflow: 'title',
  },
  {
    visible: !disabled,
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    fixed: 'right',
    slots: {
      default: 'opt',
    },
  },
]
